/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledTh = styled.th`
    background-color: #f2f2f2;
`;
